<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-make-searchable
				label="vehicles|record|make-model-section|field-label|make"
				[searchableId]="detailsForm.get('makeId')" />
			@if (showModel()) {
				<app-model-searchable
					label="vehicles|record|make-model-section|field-label|model"
					[searchableId]="detailsForm.get('modelId')"
					[filters]="modelFilters()" />
			}
		</div>

		<div>
			<app-input-field
				formControlName="year"
				[label]="'vehicles|record|make-model-section|field-label|year'"
				[isNumber]="true" />

			<app-single-dropdown
				formControlName="bodyType"
				[label]="'vehicles|record|make-model-section|field-label|body-type'"
				[selectOptions]="bodyType" />
		</div>

		<div>
			<app-input-field
				formControlName="series"
				[label]="'vehicles|record|make-model-section|field-label|series'" />
			<app-input-field
				formControlName="trim"
				[label]="'vehicles|record|make-model-section|field-label|trim'" />
		</div>
		<div>
			<app-datetime-picker
				formControlName="manufacturedAt"
				[label]="
					'vehicles|record|make-model-section|field-label|manufactured-at'
				"
				[showTime]="false"
				[excludeFutureDates]="true" />
		</div>
	</form>
</app-section-wrapper-container>
